import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { Logo } from "components/logo"
import { useAuth } from "hooks/use-auth"
import { PageLoader } from "@/components/page-loader"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { trpc } from "@/lib/trpc"
export const Route = createFileRoute("/_public/sign-up/pro/")({
  component: BetaOnboarding,
})

function BetaOnboarding() {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading: authLoading } = useAuth()

  const { data: user, isLoading: meLoading } = trpc.users.me.useQuery(undefined, {
    enabled: isAuthenticated,
  })

  const isProfessional = user?.userType === "professional"

  const handleStartAsGuest = () => {
    navigate({
      to: "/sign-up",
      search: { redirect: "/sign-up/pro" },
    })
  }

  const handleGoToDashboard = () => {
    navigate({ to: "/dashboard", search: { token: undefined } })
  }

  if (authLoading || meLoading) {
    return <PageLoader />
  }

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-8 p-6 md:py-10 md:px-0 items-center justify-center">
        <div className="w-full max-w-xs space-y-7">
          <div className="justify-center flex">
            <Logo width="max-w-[300px] max-h-[300px]" />
          </div>

          <h1 className="text-3xl font-light text-center">
            Welcome to <br />
            <span className="font-bold">Legacy Keeper</span> <br />
            <span className="text-teal-600 italic">Pro</span>
          </h1>

          <div className="space-y-4 text-center">
            <h2 className="text-xl">
              Access the Legacy Keeper professional dashboard to gain estate planning insights for
              individual clients
            </h2>

            <p className="text-sm text-center">
              {!isAuthenticated ? (
                <span>Sign up to get started with 3 free clients.</span>
              ) : (
                <>
                  <a
                    href="https://app.apollo.io/#/meet/jon_mason_ca6"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-teal-600 underline hover:text-teal-700"
                  >
                    Book a demo
                  </a>{" "}
                  to access:
                </>
              )}
            </p>

            <ul className="space-y-3 text-sm">
              <li className="bg-teal-50 border-2 border-teal-400 rounded-sm p-3">
                <strong>3 free clients</strong> to explore the platform.
              </li>
              <li className="bg-teal-50 border-2 border-teal-400 rounded-sm p-3">
                <strong>Premium Support</strong> set onboarding meetings for additional guidance and
                support.
              </li>
              <li className="bg-teal-50 border-2 border-teal-400 rounded-sm p-3">
                <strong>Up To 50% Discounts</strong> in exchange for feedback.
              </li>
            </ul>
          </div>

          {/* Not logged in → go sign up first */}
          {!isAuthenticated && (
            <Button size="lg" className="w-full" onClick={handleStartAsGuest}>
              Sign up to get started
            </Button>
          )}

          {/* Logged in but not professional */}
          {isAuthenticated && !isProfessional && (
            <>
              <Alert variant="destructive">
                <AlertDescription>
                  This beta offer is only available for professional accounts.
                </AlertDescription>
              </Alert>
              <Button
                size="lg"
                className="w-full"
                onClick={() =>
                  navigate({
                    to: "/dashboard",
                    search: { token: undefined },
                  })
                }
              >
                Go to dashboard
              </Button>
            </>
          )}

          {/* Logged in + professional */}
          {isAuthenticated && isProfessional && (
            <Button size="lg" className="w-full" onClick={handleGoToDashboard}>
              Get started
            </Button>
          )}
        </div>
      </div>

      <div className="bg-sky-100 p-12 flex items-center justify-center">
        <img src="/images/login_illustration.svg" alt="Illustration" className="object-contain" />
      </div>
    </div>
  )
}
